import layerMap from '@/utils/configs/layerMap'
import Store from '@/store'
export default {
  // 标牌宽度 根据scatterType配置
  getPanelIfon(res) {
    let { sceneName } = Store.state
    //nameArea是类型区域图参数
    let { idLayer, idObj, nameArea } = res;
    let layerData = layerMap[sceneName][idLayer];
    if (!layerData) {
      return null;
    }
    let { layerType, scatterType, rawData } = layerData.layerConfig;
    let pointData = rawData.filter((item, index) => {
      if (item.id == idObj) {
        item.layerType = layerType;
        item.scatterType = scatterType;
        return item;
      }
    })[0];
    let url = null;
    let closePanelFlag = true;
    console.log('pointData', pointData,Store);
    Store.commit('setLandmarkLayerIdObj', pointData)
    return {
      idLayer,
      idObj,
      layerType,
      scatterType,
      pointData,
      url,
      closePanelFlag
    };
  }
};
